---
assets:
  name: asset
  description: Asset
  path: "/assets"
  icon:
    name: photo-film
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

chronicles:
  name: chronicle
  description: Chronicle
  path: "/chronicles"
  icon:
    name: scroll
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

classification-sets:
  name: classification_set
  description: Classification Set
  path: "/classification-sets"
  icon:
    name: tags
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

classifications:
  name: classification
  description: Classification
  path: "/classifications"
  icon:
    name: tag
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

communication-items:
  name: communication_item
  description: Communication Item
  path: "/communication-items"
  icon:
    name: message
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true

constituent-activity-logs:
  name: constituent_activity_log
  description: Constituent Activity Log
  path: "/constituent-activity-logs"
  icon:
    name: browser
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

constituent-link-visit-logs:
  name: constituent_link_visit_log
  description: Constituent Link Visit Log
  path: "/constituent-link-visit-logs"
  icon:
    name: bullseye-pointer
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

data-exports:
  name: data_export
  description: Data Export
  path: "/data-exports"
  icon:
    name: floppy-disk-circle-arrow-right
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

data-export-fields:
  name: data_export_field
  description: Data Export Field
  path: "/data-export-fields"
  icon:
    name: table-columns
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

data-imports:
  name: data_import
  description: Data Import
  path: "/data-imports"
  icon:
    name: floppy-disk-circle-arrow-right
    flip: horizontal
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

events:
  name: event
  description: Event
  path: "/events"
  icon:
    name: calendar-day
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: true
  query_enabled: true
  modal_enabled: true

event-person-stratifications:
  name: event_person_stratification
  description: Event Person Stratification
  path: "/event-person-stratifications"
  icon:
    name: chart-pie
  enabled: true
  queryable: true
  showable: false
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

external-links:
  name: external_link
  description: External Link
  path: "/external-links"
  icon:
    name: link
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

games:
  name: game
  description: Game
  path: "/games"
  icon:
    name: gamepad-modern
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: true
  query_enabled: true
  modal_enabled: true

gifts:
  name: gift
  description: Gift
  path: "/gifts"
  icon:
    name: gift
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

groups:
  name: group
  description: Group
  path: "/groups"
  icon:
    name: house-building
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

hosts:
  name: host
  description: Host
  path: "/hosts"
  icon:
    name: flag
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

hotels:
  name: hotel
  description: Hotel
  path: "/hotels"
  icon:
    name: hotel
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

hotel-reservations:
  name: hotel_reservation
  description: Hotel Reservation
  path: "/hotel-reservations"
  icon:
    name: bed
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

hotel-reservation-stays:
  name: hotel_reservation_stay
  description: Hotel Reservation Stay
  path: "/hotel-reservation-stays"
  icon:
    name: "fak:solid-bed-clock"
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: false
  modal_enabled: false

households:
  name: household
  description: Household
  path: "/households"
  icon:
    name: house
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

household-event-invitations:
  name: household_event_invitation
  description: Household Event Invitation
  path: "/household-event-invitations"
  icon:
    name: house
    mask: ticket-simple
    transform:
      shrink: 9
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

household-hotel-reservations:
  name: household_hotel_reservation
  description: Household Hotel Reservation
  path: "/household-hotel-reservations"
  icon:
    name: bed
  enabled: true
  queryable: true
  showable: false
  creatable: true
  updatable: false
  deletable: true
  duplicatable: false
  query_enabled: false
  modal_enabled: false

household-uploads:
  name: household_upload
  description: Household Upload
  path: "/household-uploads"
  icon:
    name: photo-film
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: false
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: false

inbound-emails:
  name: inbound_email
  description: Inbound Email
  path: "/inbound-emails"
  icon:
    name: message
    flip: horizontal
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

inbound-texts:
  name: inbound_text
  description: Inbound Text
  path: "/inbound-texts"
  icon:
    name: comment
    flip: horizontal
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

integrity-checks:
  name: integrity_check
  description: Integrity Check
  path: "/integrity-checks"
  icon:
    name: sensor-triangle-exclamation
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

integrity-check-results:
  name: integrity_check_result
  description: Integrity Check Result
  path: "/integrity-check-results"
  icon:
    name: triangle-exclamation
  enabled: true
  queryable: true
  showable: false
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

ip-addresses:
  name: ip_address
  description: IP Address
  path: "/ip-addresses"
  icon:
    name: router
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

kinndoms:
  name: kinndom
  description: Kinndom
  path: "/kinndoms"
  icon:
    name: castle
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

favorited-kinn-pages:
  name: favorited_kinn_page
  description: Favorited Page
  path: "/favorited-kinn-pages"
  icon:
    name: fak:solid-page-heart
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: false

kinndom-configurations:
  name: kinndom_configuration
  description: Kinndom Configuration
  path: "/kinndom-configurations"
  icon:
    name: gear-code
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

oauth-accounts:
  name: oauth_account
  description: OAuth Account
  path: "/oauth-accounts"
  icon:
    name: fingerprint
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

operations:
  name: operation
  description: Operation
  path: "/operations"
  icon:
    name: bolt
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

operation-logs:
  name: operation_log
  description: Operation Log
  path: "/operation-logs"
  icon:
    name: rectangle-list
    subIconName: bolt
  enabled: true
  queryable: true
  showable: false
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

operation-routines:
  name: operation_routine
  description: Operation Routine
  path: "/operation-routines"
  icon:
    name: alarm-clock
    subIconName: bolt
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: true
  query_enabled: true
  modal_enabled: true

outbound-emails:
  name: outbound_email
  description: Outbound Email
  path: "/outbound-emails"
  icon:
    name: message
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

outbound-email-events:
  name: outbound_email_event
  description: Outbound Email Event
  path: "/outbound-email-events"
  icon:
    name: paper-plane
  enabled: true
  queryable: true
  creatable: true
  showable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

outbound-email-templates:
  name: outbound_email_template
  description: Outbound Email Template
  path: "/outbound-email-templates"
  icon:
    name: message-code
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: true
  query_enabled: true
  modal_enabled: true

outbound-email-template-dispatchs:
  name: outbound_email_template_dispatch
  description: Outbound Email Dispatch
  path: "/outbound-email-template-dispatchs"
  icon:
    name: paper-plane-top
    subIconName: message
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: true
  query_enabled: true
  modal_enabled: true

outbound-email-template-dispatch-items:
  name: outbound_email_template_dispatch_item
  description: Outbound Email Dispatch Item
  path: "/outbound-email-template-dispatch-items"
  icon:
    name: conveyor-belt-boxes
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

outbound-email-template-themes:
  name: outbound_email_template_theme
  description: Outbound Email Template Theme
  path: "/outbound-email-template-themes"
  icon:
    name: paintbrush
    mask: message
    transform:
      shrink: 8
      up: 2
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: true
  query_enabled: true
  modal_enabled: true

outbound-mails:
  name: outbound_mail
  description: Outbound Mail
  path: "/outbound-mails"
  icon:
    name: envelope
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: false
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

outbound-mail-events:
  name: outbound_mail_event
  description: Outbound Mail Event
  path: "/outbound-mail-events"
  icon:
    name: truck-ramp-box
  enabled: true
  queryable: true
  showable: false
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: false
  modal_enabled: false

outbound-texts:
  name: outbound_text
  description: Outbound Text
  path: "/outbound-texts"
  icon:
    name: comment
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

outbound-text-templates:
  name: outbound_text_template
  description: Outbound Text Template
  path: "/outbound-text-templates"
  icon:
    name: comment-code
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: true
  query_enabled: true
  modal_enabled: true

outbound-text-template-versions:
  name: outbound_text_template_version
  description: Outbound Text Template Version
  path: "/outbound-text-template-versions"
  icon:
    name: "fak:solid-comment-circle-ellipsis"
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

outbound-text-template-dispatchs:
  name: outbound_text_template_dispatch
  description: Outbound Text Dispatch
  path: "/outbound-text-template-dispatchs"
  icon:
    name: paper-plane-top
    subIconName: comment
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: true
  query_enabled: true
  modal_enabled: true

outbound-text-template-dispatch-items:
  name: outbound_text_template_dispatch_item
  description: Outbound Text Dispatch Item
  path: "/outbound-text-template-dispatch-items"
  icon:
    name: conveyor-belt-boxes
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

persons:
  name: person
  description: Person
  path: "/persons"
  icon:
    name: user
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

person-classifications:
  name: person_classification
  description: Person Classification
  path: "/person-classifications"
  icon:
    name: user-tag
  enabled: true
  queryable: true
  creatable: true
  showable: false
  updatable: false
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

person-event-invitations:
  name: person_event_invitation
  description: Person Event Invitation
  path: "/person-event-invitations"
  icon:
    name: user
    mask: ticket-simple
    transform:
      shrink: 9
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

person-oauth-accounts:
  name: person_oauth_account
  description: Person OAuth Account
  path: "/person-oauth-accounts"
  icon:
    name: user
    subIconName: fingerprint
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

person-photos:
  name: person_photo
  description: Person Photo
  path: "/person-photos"
  icon:
    name: image-polaroid-user
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

person-relationships:
  name: person_relationship
  description: Person Relationship
  path: "/person-relationships"
  icon:
    name: people-arrows-left-right
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

person-relics:
  name: person_relic
  description: Person Relic
  path: "/person-relics"
  icon:
    name: user
    subIconName: award
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

productions:
  name: production
  description: Production
  path: "/productions"
  icon:
    name: clapperboard-play
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

production-channels:
  name: production_channel
  description: Production Channel
  path: "/production-channels"
  icon:
    name: airplay
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

queued-outbound-texts:
  name: queued_outbound_text
  description: Queued Outbound Text
  path: "/queued-outbound-texts"
  icon:
    name: comment-dots
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

relics:
  name: relic
  description: Relic
  path: "/relics"
  icon:
    name: award
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

text-services:
  name: text_service
  description: Text Service
  path: "/text-services"
  icon:
    name: phone-office
  enabled: true
  queryable: true
  creatable: true
  showable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

transaction-logs:
  name: transaction_log
  description: Transaction Log
  path: "/transaction-logs"
  icon:
    name: code-compare
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

users:
  name: user
  description: User
  path: "/users"
  icon:
    name: circle-user
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true

user-activity-logs:
  name: user_activity_log
  description: User Activity Log
  path: "/user-activity-logs"
  icon:
    name: rectangle-terminal
  enabled: true
  queryable: true
  showable: false
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

user-notifications:
  name: user_notification
  description: User Notification
  path: "/user-notifications"
  icon:
    name: bell
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

tasks:
  name: task
  description: Task
  path: "/tasks"
  icon:
    name: hexagon-check
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

visit-logs:
  name: visit_log
  description: Visit Log
  path: "/visit-logs"
  icon:
    name: arrow-pointer
  enabled: false
  queryable: false
  showable: false
  creatable: false
  updatable: false
  deletable: false
  duplicatable: false
  query_enabled: false
  modal_enabled: false

websites:
  name: website
  description: Website
  path: "/websites"
  icon:
    name: browsers
  enabled: true
  queryable: true
  showable: true
  creatable: false
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: false

website-configurations:
  name: website_configuration
  description: Website Configuration
  path: "/website-configurations"
  icon:
    name: panel-ews
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

website-content-pages:
  name: website_content_page
  description: Website Content Page
  path: "/website-content-pages"
  icon:
    name: file-invoice
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: true
  query_enabled: true
  modal_enabled: true

website-content-page-cards:
  name: website_content_page_card
  description: Website Content Page Card
  path: "/website-content-page-cards"
  icon:
    name: rectangles-mixed
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: true
  query_enabled: true
  modal_enabled: true

website-forms:
  name: website_form
  description: Website Form
  path: "/website-forms"
  icon:
    name: ballot-check
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

website-form-questions:
  name: website_form_question
  description: Website Form Question
  path: "/website-form-questions"
  icon:
    name: square-question
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

website-form-question-options:
  name: website_form_question_option
  description: Website Form Question Option
  path: "/website-form-question-options"
  icon:
    name: list-ol
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

website-form-question-responses:
  name: website_form_question_response
  description: Website Form Question Response
  path: "/website-form-question-responses"
  icon:
    name: poll-people
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: false

website-navbar-items:
  name: website_navbar_item
  description: Website Navbar Item
  path: "/website-navbar-items"
  icon:
    name: gallery-thumbnails
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: true
  duplicatable: false
  query_enabled: true
  modal_enabled: true

website-system-pages:
  name: website_system_page
  description: Website System Page
  path: "/website-system-pages"
  icon:
    name: file-code
  enabled: true
  queryable: true
  showable: true
  creatable: true
  updatable: true
  deletable: false
  duplicatable: false
  query_enabled: true
  modal_enabled: true
